import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";

export function useFetchParentCompanyAttributesForGroup(email, selectedItem, organizationType, isEnabled = true) {
    const { oktaAuth } = useOktaAuth();
    const location = useLocation();
    const dataKey = "FetchParentCompanyAttributesForGroup";

    async function FetchParentCompanyAttributesForGroup() {
        if (selectedItem === null || organizationType === null || email === null) {
            return;
        }

        let allLocationsParameters = {
            email: email,
            selectedItem: selectedItem,
            organizationType: organizationType,
            programSubscriptions: "Rec2.0",
        };
        const accessToken = oktaAuth.getAccessToken();
        let currentRoute = location.pathname;
        let allLocationsResponse = await axios.get(
            `api/UserProgram/GetGroupLevelParentCompanyAttributes`,
            {
                params: allLocationsParameters,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    RequestSrc: currentRoute,
                },
            }
        ).then((response) => {
            return response.data;
        })
            .catch((error) => {
                console.error("Error fetching parent company attributes:", error);
                throw new Error(error);
            });

        return allLocationsResponse;
    }

    return useQuery({
        queryKey: [dataKey, email, selectedItem, organizationType],
        queryFn: async () => await FetchParentCompanyAttributesForGroup(),
        enabled: isEnabled && !!email && !!selectedItem && !!organizationType,
        refetchOnWindowFocus: false
    });
}